// ═══════════════════════════════════════════════════════════════════════
//  DATOS DEL NEGOCIO — ÚNICO ARCHIVO QUE HAY QUE EDITAR
//  Nada más en la app contiene datos de contacto: todo se lee de aquí.
// ═══════════════════════════════════════════════════════════════════════

export const business = {
  // Nombre comercial (autónomo / sole trader: sin "Ltd" ni número de registro)
  name: "UNLockSmiths",

  // Teléfono SOLO como texto secundario (no se promociona la llamada)
  phoneDisplay: "+44 7432 855 266",

  // Número de WhatsApp SOLO dígitos con código de país, sin "+" ni espacios
  whatsappNumber: "447432855266",

  // Email principal (también destinatario del formulario, ver backend/.env)
  email: "uk.locksmith25@gmail.com",

  // Dominio del sitio (sin barra al final). Se usa en canonical, hreflang, OG y sitemap
  siteUrl: "https://unlocksmith-247.com",
  siteDisplay: "unlocksmith-247.com",

  // Zona principal y zonas adicionales (negocio de área de servicio, sin dirección pública)
  mainArea: "Edinburgh",
  region: "Scotland, UK",
  coverage: ["Glasgow", "West Lothian", "Livingston", "Prestonpans", "Dunfermline", "Penicuik"],

  hours: "24/7",

  // Redes sociales oficiales del negocio
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61594490923285",
    instagram: "https://www.instagram.com/unlocksmith247/",
  },

  // Ficha de Google Business verificada ("" mostraría "Google reviews coming soon")
  googleReviewsUrl: "https://share.google/n53fr8Aq4dMVMfoig",
};

// Enlace de WhatsApp con mensaje prellenado (texto según idioma activo)
const encode = (s) => encodeURIComponent(s).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
export const waLink = (message) => `https://wa.me/${business.whatsappNumber}?text=${encode(message)}`;
